export const faqData = [
  {
    q: 'What is multi-layer scheduling?',
    a: 'Multi-layer scheduling shows your schedule, tasks, documents, and team assignments as parallel layers in a single timeline. Instead of switching between 5 different apps, you see how everything connects in one view.',
  },
  {
    q: 'Does Tindlo replace Google Calendar?',
    a: 'No — Tindlo enhances it. We sync with Google Calendar so your meetings appear as one layer. Tindlo adds task, document, and people layers on top, giving you the full execution picture.',
  },
  {
    q: 'How is Tindlo different from Asana or Notion?',
    a: 'Asana focuses on tasks. Notion focuses on documents. Tindlo connects both to your schedule in a time-based view. You see what to work on, when to work on it, and everything you need to execute — together.',
  },
  {
    q: 'What team size is Tindlo best for?',
    a: 'Tindlo works for anyone — from solo users to teams of 100+. You can start on your own, but Tindlo truly shines when your team joins in. The more people collaborate on the timeline, the more powerful it becomes. Perfect for startups, agencies, product teams, and any group that wants to move fast together.',
  },
  {
    q: 'Is my data safe?',
    a: 'Yes. All data is encrypted and hosted on secure cloud infrastructure. We work with trusted third-party services to improve your experience, but we never sell your data. Your information is only used to make Tindlo better for you and your team.',
  },
  {
    q: 'Can I try Tindlo for free?',
    a: "Yes! You can start using Tindlo for free right now — no credit card needed. The Free plan stores your data for up to 50 days and comes with basic feature limits. When you're ready to unlock everything, simply upgrade to Standard for $7/month.",
  },
] as const;

export type FAQItem = (typeof faqData)[number];

// Generate FAQPage JSON-LD schema
export function generateFAQSchema(siteUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
    url: `${siteUrl}/#faq`,
  };
}
